import script from "./VideoTile.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoTile.vue?vue&type=script&setup=true&lang=js"

import "./VideoTile.vue?vue&type=style&index=0&id=0cd1ef02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd1ef02"]])

export default __exports__